import { Hud, Keyframes } from '@sloyd/animation';
import { IconDice6 } from '@sloyd/icons';
import { Button, Playback, SeekBar, Time, Transcript } from '@sloyd/ui';
import ThreeContainer from '../Three/Three.container';
import { CameraInfo } from '../Three/Three.info';
import {
  Controls,
  Extra,
  Info,
  Inner,
  Main,
  Overlay,
  Play,
  Seek,
  Side,
  Timeline,
  Wrapper,
} from './ContentThree.style';
import hudData from './hud.json';

export type ContentThreeProps = {
  animationState: IAnimationState;
  keyframes: IKeyframe[];
  storyLines: IStoryLine[];

  callbacks: {
    onLoad: () => void;
    onAction: OnAction;
  };
};

const DEFAULT_SPEAKERS = {
  Narrator: { id: 1, name: 'Narrator' },
};

export function ContentThree(props: ContentThreeProps) {
  const { animationState, keyframes, storyLines, callbacks } = props;
  const { showHud, isRunning } = animationState;

  function renderHud() {
    if (!showHud) return null;

    return (
      <Overlay>
        <Hud json={hudData} />
      </Overlay>
    );
  }

  return (
    <Wrapper className='ContentThree-wrapper' data-testid='ContentThree-wrapper'>
      <Inner>
        <Main>
          <ThreeContainer />
          {renderHud()}
        </Main>
        <Side>
          <Button variant='outline' color='purple' leftSection={<IconDice6 />}>
            Generate Script
          </Button>
          <Transcript
            sentences={storyLines}
            currentIndex={animationState.storyLineIndex}
            speakers={DEFAULT_SPEAKERS}
            hideSpeaker
          />
        </Side>
        <Timeline>
          <Controls>
            <Play>
              <Playback isRunning={isRunning} onAction={callbacks.onAction} />
            </Play>
            <Seek>
              <SeekBar isRunning={isRunning} duration={15} />
            </Seek>
            <Keyframes type='camera' keyframes={keyframes} iconName='IconVideo' />
            <Keyframes type='audio' keyframes={keyframes} iconName='IconMicrophone' />
            <Keyframes type='hud' keyframes={keyframes} iconName='IconFocus' />
          </Controls>
        </Timeline>
        <Extra>
          <Info>
            <Time />
            <CameraInfo />
          </Info>
        </Extra>
      </Inner>
    </Wrapper>
  );
}

export default ContentThree;
